import * as CONSTANT from "../../constants";
import { creatingModifiersForItems } from "../helperMethods";
import {
  COMBO_TYPE_IS_KIDS_COMBO,
  COMBO_TYPE_IS_TRY_2_COMBO, HALF_SIZE,
} from "../../constants";
import { Codes } from "../../models/item.model";
import { itemBuckets } from "../../priceCalculation/buckets";
import _clonedeep from 'lodash.clonedeep'

interface IFinalOrder {
  order: any;
  category_id: number;
  noOfItems: number;
  comboType: string;
  items: any;
  state: any;
  allRewards: any;
}

export const finalOrder: React.FC<IFinalOrder> = (props) => {
  const { order, category_id, noOfItems, comboType, items, state, allRewards } = props;
  let {
    item_id,
    modifiers,
    name,
    display_price,
    original_price,
    item_calories,
    brink_id,
  } = _clonedeep(order);
  modifiers = creatingModifiersForItems(modifiers, noOfItems);
  const payload:any = {
    item_size: CONSTANT.FULL_SIZE.id,
    item_id,
    name,
    display_price,
    price: display_price,
    original_price,
    item_calories,
    modifiers,
    brink_id,
    category_id,
    id: item_id,
    free: false,
  };
  if (comboType === COMBO_TYPE_IS_KIDS_COMBO) payload.isKidsCombo = true;
  else if (comboType === COMBO_TYPE_IS_TRY_2_COMBO) payload.isTry2Combo = true;

  //ADDING NO DRESSING IN MODIFIERS
  if ( comboType === COMBO_TYPE_IS_TRY_2_COMBO ) {
  for(let i = 0 ; i < CONSTANT.TRY_TO_COMBO_SELECTED_SECTION; i++ ){
    const selectedModifier = itemBuckets.getSingleBucket({name:CONSTANT.REQUIRED_MODIFIERS,fromItem:i, isFromItemComingAsAnIndex:true});
    if(selectedModifier?.noDressings){
        const category = items?.sub_categories.find(category => category.id === modifiers[i].category_id)
        const item = category.items.find(categoryItem => categoryItem.id === modifiers[i].modifier_id )
        selectedModifier?.noDressings.forEach(dressingItem => {
          if(dressingItem?.noDressing){
            const noDressItem = item?.items_required_modifier_groups.find(e => e?.id === dressingItem.id)
            const noDressingPayload = {
              modifier_id: 0,
              item_id: 0,
              modifier_name: noDressItem?.label,
              modifier_label: `No ${noDressItem?.label}`,
              display_price: 0,
              modifier_calories: 0,
              brink_id: 0,
              quantity: 0,
              modifier_group_min: 0,
              max: 0,
              type: CONSTANT.SELECTED,
              code: Codes.NO,
              extendableLimitValue: 0,
              modifier_group_id: noDressItem?.id,
              modifier_group_max: noDressItem?.max,
              in_item: 0,
              in_slide: false,
              modifier_type: CONSTANT.REQUIRED_MODIFIERS,
              additionalPrice: 0,
              is_no_modifier_selected: 1
            }
            if( !payload.modifiers[i].modifiers ) payload.modifiers[i].modifiers = []
            payload.modifiers[i].modifiers.push(noDressingPayload)
          }
        });
      }
    }
  }
  if (state?.reward_size) {
    const itemFoundInRewards = allRewards?.rewards.filter((reward) => {
      if (reward.redirect_item_id) {
        return (
            !reward.is_active_in_cart &&
            reward.redirect_item_id == order.item_id &&
            !reward.is_redeemed && !reward.is_expired
        );
      }
      return (
          !reward.is_active_in_cart &&
          reward.redirect_category_id == category_id &&
          !reward.is_redeemed && !reward.is_expired
      );
    });
    itemFoundInRewards.sort((a, b) => {
      if (a.redirect_item_id) {
        return -1;
      }
      return 1;
    });
    if (itemFoundInRewards.length) {
      payload['reward_id'] = itemFoundInRewards[0]?.loyalty_id
      payload['reward_redeemed'] = true
      payload['points'] = itemFoundInRewards[0].points
    }
  }
  payload['redeem_points'] = items?.half_loyalty_points || items?.full_loyalty_points
  return payload;
};
